import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

//const store = new Vuex.store({
//	state:{
//		uid:"",
//	}
//})

export default new Vuex.Store({
  state:{
    //导航列表
    nav:[
      {
        name:'年会流程',
        index:1,
        router:"/rule",
      },
      {
        name:'弹幕互动',
        index:2,
        router:"/popup",
      },
      {
        name:'中奖查询',
        index:3,
        router:"/upload",
      },
      {
        name:'节目投票',
        index:4,
        router:"/choose",
      },
      
    ],
    // 当前选中
    navIndex: {
      name:'签到记录',
      index:1
    },
      
    //导航列表
    adminNav:[
      {
        name:'年会流程',
        index:1,
        router:"/",
      },
      {
        name:'弹幕互动',
        index:2,
        router:"/popup",
      },
      {
        name:'奖项设置',
        index:3,
        router:"/upload",
      },
      {
        name:'节目投票',
        index:4,
        router:"/choose",
      },
      
    ],
    // 当前选中
    adminIndex: {
      name:'签到记录',
      index:1
    },
  },
  mutations:{
    // 修改导航状态
		navChange(state,data){
      state.navIndex = data;
		},
    // admin修改导航状态
		adminnavChange(state,data){
      state.adminIndex = data;
		},
    decrement:state => state.count --,
  }
})




// WEBPACK FOOTER //
// ./src/store.js